import React from "react";
import {cx} from "../../lib/ClassSet";
import "./CustomerItem.css";

const CustomerItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "accounts-customer-list-item": true,
    "u-selected": props.selected,
    "u-active-sub": data.get("subsActive") > 0,
    "u-cancelled-sub": data.get("subsCancelled") > 0,
    "u-paused-sub": data.get("subsPaused") > 0
  })

  let auth = "No";
  if (data.get("authProvisioned")) {
    auth = "Yes";
  } else if (data.get("authInvited")) {
    auth = "Invited";
  }

  const email = data.get("email")
  const name = email.startsWith("deleted_") ? "Deleted customer" : data.get("name");

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id" onClick={(e) => props.onClick(data, e, "id")}>{data.get("customerId")}</td>
      <td className="field f-name">{name}</td>
      <td className="field f-email">{email}</td>
      <td className="field f-subsActive" title="Active subscriptions">{data.get("subsActive")}</td>
      <td className="field f-subsPaused" title="Paused subscriptions">{data.get("subsPaused")}</td>
      <td className="field f-subsCancelled" title="Cancelled subscriptions">{data.get("subsCancelled")}</td>
      <td className="field f-auth">{auth}</td>
      <td className="field f-code">{data.get("referralCode", "")}</td>
    </tr>
  )
}

export default CustomerItem;